<template>
  <div width="100%" class="pa-2">
    <v-card elevation="0">
      <v-card-title>
        {{ $t('message.documents_for') }}
        <span class="ml-1 font-weight-bold" v-if="member">{{ member.fName }} {{ member.lName }}</span>
      </v-card-title>
      <div>
        <div v-if="loadingMember" class="text-center">
          <v-progress-circular indeterminate color="primary" size="100">
          </v-progress-circular>
        </div>
        <div v-else-if="member">
          <v-card-text>
            <v-btn class="mt-1" @click="goToDoc(i)" block large color="primary" v-for="i of pendingDocuments"
              :key="'pending_doc_' + i.objectId">
              {{ i.text }}
            </v-btn>
          </v-card-text>
        </div>
        <div v-else class="text-center text-h4">
          {{ $t('message.invalid_member') }}
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Api from "@/services/Api";
//import SelfieInput from '@/components/inputs/SelfieInput.vue';
//<SelfieInput v-if="selectedMemberId" :member-id="selectedMemberId"></SelfieInput>
export default {
  name: 'Checkin',
  data() {
    return {
      memberId: this.$route.params.memberId,
      loadingMember: true,
      member: null,
      pendingDocuments: [],
    }
  },
  created() {
    this.getMember();
  },
  methods: {
    goToDoc(i) {
      this.navigateTo({ name: 'template', params: { templateId: i.objectId, memberId: this.memberId } })
    },
    getMember() {
      Api()
        .get(
          "admintablet/academy/" +
          this.$store.state.tabletManagedAcademy +
          "/member/" + this.memberId
        )
        .then(response => {
          this.member = response.data.member;
          if (response.data.alerts) {
            for (const i of response.data.alerts) {
              if (i.type == 'alert_missing_document')
                this.pendingDocuments.push(i)
            }
          }
          this.loadingMember = false;
        });
    },
  }
}
</script>

<style scoped>
.camera-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

video,
img {
  width: 320px;
  height: 320px;
  object-fit: cover;
  border: 2px solid #333;
  border-radius: 8px;
  margin-bottom: 10px;
}

.controls button {
  margin: 5px;
}
</style>
